import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgLocationPinFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.736 20.91a24.928 24.928 0 0 0 2.507-2.411C18.58 15.904 20 13.166 20 10.364 20 5.756 16.43 2 12 2s-8 3.756-8 8.364c0 2.801 1.42 5.54 3.757 8.135a24.923 24.923 0 0 0 3.337 3.075c.154.117.267.2.332.245a1 1 0 0 0 1.148 0 22.45 22.45 0 0 0 1.162-.909ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z", fill: color }));
};
export default factorySvgIcon(SvgLocationPinFilled);
//# sourceMappingURL=SvgLocationPinFilled.js.map